import React, {useEffect, useState} from 'react'
import {Row, Col, Form, Table, Spin} from 'antd'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import logo from '../static/images/New_logo.jpg'
import axios from 'axios'
import moment from 'moment'
import apiRequest from '../hooks/ApiRequest'

const columns = [
  {
    title: 'Endorsed Policy Number',
    dataIndex: 'policynumber',
    key: 'endorsednumber',
  },
  {
    title: 'Risk Cover',
    dataIndex: 'policy_cover',
    key: 'policyriskcover',
  },
  {
    title: 'Risk Item',
    dataIndex: 'riskitemname',
    key: 'riskitemname',
  },
  {
    title: 'Sum Insured',
    dataIndex: 'suminsured',
    key: 'suminsured',
  },
  {
    title: 'Added On',
    dataIndex: 'createddate',
    key: 'createddate',
    render: createddate => moment(createddate).format('YYYY-MM-DD'),
  },
]
const PolicyHistory = props => {
  const [credHistoryData, setCredHistoryData] = useState([])
  const [loader, setLoader] = useState(false)
  const fetchData = async (policyNumber, productId) => {
    try {
      setLoader(true)
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL+`/Policy/GetPolicyHistoryById/${policyNumber}` , 'GET'
      )
      const data = response.data
      // debugger
      console.log('data', data)
      setCredHistoryData(data)
      setLoader(false)
    } catch (error) {
      setLoader(false)
      console.error('Error fetching data:', error)
    }
  }

  console.log(credHistoryData[0])

  useEffect(() => {
    // debugger
    setCredHistoryData([])
    props?.policyNumber &&
      props.productId &&
      fetchData(props.policyNumber, props.productId)
    // console.log(props) // Console logging all props

    // Add any other code that needs to be executed when props change

    return () => {
      // Clean up any resources or subscriptions here if needed
    }
  }, [props?.policyNumber && props.productId])

  return (
    <div
      className="container-box"
      style={{margin: '15px auto 0', width: '100%', maxWidth: '100%'}}>
      <Spin className="loader-icon-fixed" spinning={loader} size="large"></Spin>

      <Table dataSource={credHistoryData} columns={columns} />
    </div>
  )
}

const WrappedCreditHistory = Form.create({name: 'Homeinsurance_list'})(
  PolicyHistory,
)

export default WrappedCreditHistory
